import image1 from '@/assets/news/20210619_1.jpg'
import image2 from '@/assets/news/20210619_2.png'
import image3 from '@/assets/news/20210619_3.png'

export default {
  zh: {
    title: '北京合生基因与浙江海昶生物签约联合研发新型核酸疫苗',
    abstract: '6月16日，北京合生基因科技有限公司与浙江海昶生物医药技术有限公司战略合作协议签约仪式在北京中关村生命园国际会议中心举行。',
    cover: image1,
    content: `
  <div style="text-align:center"><img src="${image1}"></img></div>
  <p>6月16日，北京合生基因科技有限公司与浙江海昶生物医药技术有限公司战略合作协议签约仪式在北京中关村生命园国际会议中心举行。合生基因致力于应用合成生物学技术研究并开发创新基因与细胞治疗药药物，海昶生物是一家拥有原创RNA给药技术--QTsome，聚焦疫苗、肿瘤、CNS等领域创新药物开发的生物医药公司。</p>
  <p>此次，合生基因与海昶生物签署战略合作协议，依托双方的技术平台和资源优势，推动新型核酸（mRNA） 药物（包括核酸疫苗）研发体系的建设，以满足重大疾病预防与治疗的临床需求。</p>
  <p>2020年，新冠疫情的爆发点燃了药企对于RNA赛道的热情。随着国产新冠灭活、腺病毒及重组蛋白疫苗相继获批，mRNA疫苗的进度成为人们关注的焦点。RNA已经成为目前市场不可忽视的药物研发方向。与此同时，后疫情时代的到来也让人们对于RNA 疗法的未来充满无限遐想。</p>
  <h3>关于合生基因</h3>
  <div style="text-align:center"><img src="${image2}" style="width:160px"></img></div>
  <p>北京合生基因科技有限公司致力于BT+IT融合的合成生物技术创新，及其在基因药物设计合成上的应用，已建立了基于高通量筛选与机器学习相结合的人工基因调控元件和线路智能化设计平台。合生基因利用该技术平台开发了可特异性区分肝癌细胞与正常细胞人工DNA调控元件，并用于靶向肝癌溶瘤病毒产品开发。相关溶瘤病毒产品已获得FDA一期临床试验许可。</p>
  <h3>关于海昶生物</h3>
  <div style="text-align:center"><img src="${image3}" style="width:234px"></img></div>
  <p>浙江海昶生物医药技术有限公司成立于2013年，由前FDA高级审评专家赵孝斌博士创立，是一家致力于生物医药技术研发的国家高新技术企业。公司紧紧围绕“分享、进取、求真、务实”的核心价值观，专注于mRNA疫苗、RNA药物递送、脂质体纳米药物等领域产品的开发。公司针对全球市场，采取创仿结合的开发策略，覆盖肿瘤、镇痛及抗感染等领域，具备极具竞争力的产品管线，目标成为集研发、生产、销售一体的国际化制药公司。</p>
    `
  }
}
